import Snippet from '../../../../components/Snippet/Snippet'
import { intro } from '../../../../assets/code-snippets/column/snip'

const ColumnIntro = () => {
    return <div className="container fluid" id="basics">

        <div className="container fluid">
            <p className="text xl"><a className="link" href="#basics">&#128279;</a> Columns by <span
                className="bold">Flexbox</span>
            </p>
            <p className="text lg secondary">A simple an efficient way of building <span
                className="bold">responsive</span> columns
 </p>
        </div>

        <div className="container fluid pt-3">
            <p className="text md">Creating columns layout in <code>POKE-CSS</code> is very simple:</p>
            <ol>
                <li>
                    <p className="text sm">Add a <code>div</code> tag to your HTML doc and a class as
             <code>row</code> to it
         </p>
                </li>
                <li>
                    <p className="text sm">Add another <code>div</code> tag element having included
             <code>col</code> and also <code>auto</code> class
         </p>
                </li>
            </ol>
        </div>

        <div className="container sm py-2">

            <Snippet code={intro} language='html' />
        </div>

        <div className="container fluid py-5">
            <div className="row">
                <div className="col auto info border-light p-2 text-center">col</div>
                <div className="col auto info border-light p-2 text-center">col</div>
                <div className="col auto info border-light p-2 text-center">col</div>
                <div className="col auto info border-light p-2 text-center">col</div>
            </div>
        </div>

        <div className="container fluid">
            <p className="text sm">
                We can add as many columns we wish by using class <code>auto</code> for each tag
     element, as each of these will increase or decrease in size
     depending of how many elements are inside the
     row. Even if the columns are congestioned inside a single row <code>flexbox</code> will
     force the overflow to fall below initial row if total width of each column's inner content
     is reached by left and right sides of the column.
 </p>
        </div>

    </div>

}
export default ColumnIntro